import React from 'react';
import "./Error.scss"
const InputError = ({ message, style }) => {
    return <div className='input-error' style={style}>
        {message}
    </div>
}

export default InputError;
